import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, DatePicker, Form, Image, Modal, Popconfirm, Row, Typography, Upload, message, theme } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import dayjs from "dayjs";
import { API_BASE_URL } from "../../config/serverApiConfig";
import { weekdayKu } from "../../utils/surgeryAppointments";
import { hqSrc, thumbSrc } from "../../utils/imageVariant";
import "./styles.css";

const { Title } = Typography;

function dummyRequest({ onSuccess }) {
  setTimeout(() => onSuccess("ok"), 0);
}

function NotesPatient({ onTabCount }) {
  const { useToken } = theme;
  const { token } = useToken();
  const { id } = useParams();
  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [editing, setEditing] = useState(null);
  const [data, setData] = useState([]);
  const [NoteForm] = Form.useForm();

  const handleDelete = (rec) => {
    axios
      .delete(`${API_BASE_URL}patient/note/${rec.id}`)
      .then(() => {
        setData((prev) => prev.filter((item) => item.id !== rec.id));
        onTabCount?.("notes", -1);
      })
      .catch(() => {
        message.error("هەڵەیەک هەیە لە سڕینەوەی تێبینی");
      });
  };

  const openAdd = () => {
    setEditing(null);
    NoteForm.setFieldsValue({ date: dayjs(), upload: undefined });
    setVisible(true);
  };

  const openEdit = (item) => {
    setEditing(item);
    NoteForm.setFieldsValue({
      date: item.date ? dayjs(item.date) : dayjs(),
      upload: undefined,
    });
    setVisible(true);
  };

  const closeModal = () => {
    setVisible(false);
    setEditing(null);
    NoteForm.resetFields();
  };

  const submitWork = (value) => {
    const file = value.upload?.fileList?.[0]?.originFileObj;
    if (!editing && !file) {
      return message.warning("تکایە وێنەیەک هەڵبژێرە");
    }

    setConfirmLoading(true);
    const date = dayjs(value.date || dayjs()).format("YYYY-MM-DD");
    const params = new URLSearchParams();
    params.append("date", date);
    params.append("p_id", id);

    const request = editing
      ? file
        ? (() => {
            const formData = new FormData();
            formData.append("image", file);
            return axios.put(`${API_BASE_URL}patient/note/${editing.id}?${params}`, formData);
          })()
        : axios.put(`${API_BASE_URL}patient/note/${editing.id}?${params}`)
      : (() => {
          const formData = new FormData();
          formData.append("image", file);
          return axios.post(`${API_BASE_URL}patient/note?p_id=${id}`, formData);
        })();

    request
      .then((res) => {
        if (editing) {
          setData((prev) => prev.map((item) => (item.id === editing.id ? res.data : item)));
          message.success("تێبینی نوێکرایەوە");
        } else {
          setData((prev) => [...prev, res.data]);
          onTabCount?.("notes", 1);
          message.success("تێبینی زیادکرا");
        }
        closeModal();
      })
      .catch(() => {
        message.error(editing ? "هەڵەیەک هەیە لە نوێکردنەوەی تێبینی" : "هەڵەیەک هەیە لە زیادکردنی تێبینی");
      })
      .finally(() => setConfirmLoading(false));
  };

  useEffect(() => {
    axios.get(`${API_BASE_URL}patient/note/${id}`).then((res) => {
      console.log(res.data);
      
      setData(res.data);
    });
  }, [id]);

  return (
    <div>
      <Row className="tab-head" style={{ marginTop: 0, borderRadius: 6, padding: 10, backgroundColor: token.colorBgContainer }}>
        <Title level={4} style={{ margin: 0 }}>
          تێبینی
        </Title>
        <Button className="tab-head-action" onClick={openAdd} type="primary">
          زیادکردن
        </Button>
      </Row>

      <div className="apt-list note-tab-list">
        {data.length === 0 ? <div className="apt-empty">هیچ تێبینێک نییە.</div> : null}
        <Image.PreviewGroup>
          {data.map((item) => (
            <article key={item.id} className="apt-card">
              <div className="apt-card-top">
                <div className="apt-step apt-step-visit">
                  <div>
                    <div className="apt-step-label">تێبینی</div>
                    <div className="apt-step-day">{item.date ? weekdayKu(item.date) : "—"}</div>
                    <div className="apt-step-date">{item.date ? dayjs(item.date).format("YYYY/MM/DD") : "—"}</div>
                  </div>
                </div>
                <div className="note-tab-actions">
                  <Button type="text" icon={<EditOutlined />} onClick={() => openEdit(item)} />
                  <Popconfirm onConfirm={() => handleDelete(item)} title="ئایا دڵنیایت لە سڕینەوەی تێبینی؟" okText="بەڵێ" cancelText="نەخێر">
                    <Button danger type="text" icon={<DeleteOutlined />} />
                  </Popconfirm>
                </div>
              </div>
              {item.image ? (
                <div className="note-tab-photo">
                  <Image src={thumbSrc(item.image)} alt="تێبینی" preview={{ src: hqSrc(item.image) }} />
                </div>
              ) : null}
              {(item.patients || []).length > 1 ? (
                <div className="note-tab-people">
                  {item.patients.map((patient) => (
                    <span key={patient.id} className="note-tab-chip">
                      {patient.fullName}
                    </span>
                  ))}
                </div>
              ) : null}
            </article>
          ))}
        </Image.PreviewGroup>
      </div>

      <Modal
        onOk={() => NoteForm.submit()}
        open={visible}
        centered
        okText={editing ? "نوێکردنەوە" : "زیادکردن"}
        cancelText="پاشگەزبوونەوە"
        confirmLoading={confirmLoading}
        onCancel={closeModal}
        title={
          <Title style={{ color: "#59114d" }} level={5}>
            {editing ? "دەستکاری تێبینی" : "زیاد کردنی تێبینی"}
          </Title>
        }
      >
        <Form form={NoteForm} layout="vertical" onFinish={submitWork}>
          <Form.Item label="بەروار" name="date" rules={[{ required: true, message: "بەروار پێویستە" }]}>
            <DatePicker style={{ width: "100%" }} getPopupContainer={() => document.body} />
          </Form.Item>
          <Form.Item label="وێنە" name="upload">
            <Upload listType="picture-card" maxCount={1} accept="image/*" customRequest={dummyRequest}>
              Upload
            </Upload>
          </Form.Item>
          {editing?.image ? <img className="note-tab-preview" src={thumbSrc(editing.image)} alt="" /> : null}
        </Form>
      </Modal>
    </div>
  );
}

export default NotesPatient;
